import React, { useState } from "react";
import contentfulClient from "../../../../services/contentful";
import { useQuery } from "react-query";
import { getSection } from "src/hooks/useContentful/getSection";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import * as S from "./styles";
import Loading from "src/components/Loading";
import Footer from "./Footer";
import Plans from "./Plans";
import { addHours, format, isWithinInterval, parseISO } from "date-fns";

function Planos() {
  const [selectedTab, setSelectedTab] = useState(1);
  const content = useFetchContent();

  const section = getSection({
    sectionName: "landingDefaultPromo",
    data: content.data,
  });

  const typePlans = ["pedagiosEstacionamentos", "estacionamentos", "pedagios"];

  const plans = useQuery(
    "getCardPlan",
    () =>
      Promise.all(
        typePlans
          .filter((field) => Object.keys(section).includes(field))
          .map(
            async (field) =>
              await contentfulClient.getEntry(section[field].sys.id)
          )
      ),
    {
      enabled: content.data && !content.isLoading,
      retry: false,
    }
  );

  if (!plans.data) return <Loading />;

  const adesaoText = () => {
    const startDate = parseISO('2024-10-15 00:00:00')
    const endDate = parseISO('2024-12-14 23:59:59')

    const today = format(new Date(), 'yyyy-MM-dd HH:mm:ss')
    const dateToCheck = parseISO(today)

    const withinInterval = isWithinInterval(dateToCheck, { start: startDate, end: endDate })

    if(withinInterval) return '+ taxa única de adesão Grátis**'

		return "+ Adesão única de apenas R$20 por tag"
	}

  const bonusText = () => {
		const bonusStart = addHours(new Date('2024-10-15'), 3)
		const bonusEnd = addHours(new Date('2024-12-14'), 3)
		const today = addHours(new Date(), 3)

    const isBetween = isWithinInterval(today, { start: bonusStart, end: bonusEnd });

		if(isBetween) return "**Válido até 14/12/2024; depois R$20 por tag."

		return null
  }

  const newPlans = {
    data: [
      {
        fields: {
          benefits: [
            {
              tab: "Cartões de crédito",
              cards: [
                {
                  title: "1 tag com mensalidade grátis!",
                  benefits: [
                    "Para cartões com faturas a partir de R$2mil*",
                    adesaoText(),
                  ],
                  info: bonusText(),
                  footer: [
                    "Não atingiu a fatura mínima? A mensalidade sairá por apenas R$5.",
                  ],
                },
                {
                  title: "2 tags com mensalidade grátis!",
                  benefits: [
                    "Para cartões com faturas a partir de R$5mil*",
                    adesaoText(),
                  ],
                  info: bonusText(),
                  footer: [
                    "Não atingiu o valor da fatura? A mensalidade sairá por apenas R$5.",
                  ],
                },
              ],
            },
            {
              tab: "Cartões de débito",
              cards: [
                {
                  title: "Por apenas R$5 ao mês",
                  benefits: [
                    adesaoText(),
                    "Se preferir, peça seu cartão de crédito através do app Bradesco ou fale com seu gerente",
                  ],
                  footer: [],
                },
              ],
            },
          ],
        },
      },
    ],
  };

  const fields = newPlans.data.map((item) => item.fields);
  const { benefits } = fields.length > 0 ? fields[0] : { benefits: [] };

  return (
    <S.Container id="plans">
      <S.Title>{section.title}</S.Title>
      <S.Content>
        <S.ContainerPlan>
          <Plans benefits={benefits} setSelectedTab={setSelectedTab} />
        </S.ContainerPlan>
        <S.MainImage>
          <div />
          <img
            src="/bradescoprime/assets/cartao-tag-bradescoprime.svg"
            alt="Tag Bradesco Prime"
          />
        </S.MainImage>
      </S.Content>

      <Footer
        buttonColor={section.buttonColor}
        terms={section.regulamento}
        textColor={"#FFFFFF"}
        cupons={[plans.data[0].fields.firstButtonCoupon]}
        selectedTab={selectedTab}
      />
    </S.Container>
  );
}
export default Planos;
